import { useTranslation } from "react-i18next";

import { Button } from "@profitlens/ui/button";

/** 表格底部分页条：页数 ≤ 1 时不渲染。 */
export function Pagination({
  page,
  pageSize,
  total,
  onPage,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPage: (p: number) => void;
}) {
  const { t } = useTranslation();
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (pages <= 1) return null;
  return (
    <div className="flex items-center justify-between gap-2 border-t border-border px-3 py-2 text-sm">
      <span className="text-xs text-muted">{t("common.totalRows", { total })}</span>
      <div className="flex items-center gap-2">
        <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          {t("common.prevPage")}
        </Button>
        <span className="tabular-nums text-muted">{t("common.pageOf", { page, pages })}</span>
        <Button
          size="sm"
          variant="outline"
          disabled={page >= pages}
          onClick={() => onPage(page + 1)}
        >
          {t("common.nextPage")}
        </Button>
      </div>
    </div>
  );
}
